import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { notification } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import { GlobalAlert } from "../../interfaces/Global.interface";
import { RootState } from "../../app/store";
import { refusedServersIn, serversMessage } from "../../utils/serverScopeRefusal";

function GlobalAlert2({ isError, isSuccess, requestType, error, name }: GlobalAlert) {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const [t] = useTranslation("global");
  type NotificationType = "success" | "info" | "warning" | "error";

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const { userLogged, theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const launchNotification = (title: string, status: NotificationType) => {
    let description = "";
    if (error) {
      const refused = refusedServersIn(error?.data);
      if (refused.length > 0) {
        description = serversMessage(refused);
      } else if (error && error.data && error.data.message) {
        description = error.data.message;
      } else {
        description = "Error";
      }
    } else if (requestType === "POST") {
      description = `${name} ${t("general.alertPost")}`;
    } else if (requestType === "PUT") {
      description = `${name} ${t("general.alertPut")}`;
    } else if (requestType === "DELETE") {
      description = `${name} ${t("general.alertDelete")}`;
    }
    //
    if (userLogged.globalNotifications) {
      notification[status]({
        message: title,
        description,
        placement: "top",
        className: `monitoring__notification__${theme}`,
      });
    }
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (isSuccess) {
      launchNotification(t("general.success"), "success");
    }
    if (isError) {
      launchNotification(t("general.error"), "error");
    }
  }, [isSuccess, isError]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <div id="global-alert" />
    </div>
  );
}

export default GlobalAlert2;
